import { render } from "./GeRenDetail.vue?vue&type=template&id=3f88f2a8&scoped=true"
import script from "./GeRenDetail.vue?vue&type=script&lang=js"
export * from "./GeRenDetail.vue?vue&type=script&lang=js"

import "./GeRenDetail.vue?vue&type=style&index=0&id=3f88f2a8&scoped=true&lang=less"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f88f2a8"]])

export default __exports__